module.exports = __webpack_public_path__ + "static/img/iconfont.c1a0103.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/iconfont.svg?t=1589351592175
// module id = VTKK
// module chunks = 1